import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import ServiciosGrid from './ServiciosGrid.js'
import ServiciosAbm from './ServiciosAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';

class Servicios extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="Gerenciadores.header_administracion_de_servicios" defaultMessage="Administración de Servicios "/></h3>
      				</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={ServiciosGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <ServiciosAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <ServiciosAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <ServiciosAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
	    );
  	}
}

export default Servicios;
